export interface Testimonial {
  name: string;
  company: string;
  text: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "Sarah P.",
    company: "Head of Design",
    text: "Working with Suzanne was a game-changer for our project. Her technical expertise and design sensibility are outstanding."
  },  
  {
    name: "Ethan",
    company: "NuevoCloud",
    text: "Our documentation looks awesome! Technical and well put together."
  },
  {
    name: "Rita C.",
    company: "TruSightVR",
    text: "Awesome working with you Suzanne. My site is more than I imagined!"
  },
  {
    name: "Michael S.",
    company: "VP of Engineering",
    text: "Exceptional attention to detail and a true professional. The UI/UX improvements transformed our application."
  },
  {
    name: "D. Brewer",
    company: "InSightPD",
    text: "Good Work! Thank you for updating our testing server and production sites. Really good work."
  },
  {
    name: "Lena M.",
    company: "Cheif Operating Officer",
    text: "Suzanne brought clarity and creativity to our product interface. Her ability to blend function with aesthetics is unmatched."
  },
  {
    name: "Carlos R.",
    company: "HealthTech",
    text: "Fast, reliable, and deeply knowledgeable. Suzanne elevated our frontend experience beyond expectations."
  },
  {
    name: "Jamie T.",
    company: "Owner",
    text: "We were impressed with the seamless collaboration and the high-quality code delivery. Suzanne is an absolute pro."
  },
  {
    name: "Nina D.",
    company: "Marketing Manager",
    text: "Suzanne’s design instincts and technical skills were exactly what we needed. She nailed the look and feel on the first go-around."
  },
  {
    name: "Mark L.",
    company: "Fleet Software, VP of Engineering",
    text: "From kickoff to launch, Suzanne was instrumental in shaping a user experience our customers now rave about."
  }
]; 